<template>
  <div class="drawer__favorites" :class="{ 'is-open': isOpen }">
    <div class="drawer__content">
      <a class="drawer__handle" href @click.prevent="toggleDrawerContent()">
        <span v-if="isOpen"
          ><i class="el-icon-arrow-down"></i>{{ $t('favoritesHide')
          }}<i class="el-icon-arrow-down"></i
        ></span>
        <span v-if="!isOpen"
          ><i class="el-icon-arrow-up"></i>{{ $t('favoritesShow')
          }}<i class="el-icon-arrow-up"></i
        ></span>
      </a>
      <div class="scroll-contain">
        <favorites-comp></favorites-comp>
      </div>
    </div>
  </div>
</template>

<script>
import FavoritesComp from './FavoritesComp.vue';

export default {
  name: 'FavoritesDrawer',
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleDrawerContent() {
      this.isOpen = !this.isOpen;
    },
  },
  components: {
    FavoritesComp,
  },
};
</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';

.drawer {
  &__favorites {
    position: fixed;
    z-index: 500;
    top: 50px;
    left: 0;
    bottom: 0;
    transition: transform 200ms, width 200ms;
    transform: translate3d(-100%, 0, 0);

    @include res(md) {
      top: 105px;
    }
  }

  &__content {
    position: relative;
    width: 280px;
    height: 100%;
    background: #dddddd;
  }

  &__handle {
    display: block;

    height: 20px;
    min-width: 160px;

    position: absolute;
    top: 50%;
    left: calc(100% + 7px);
    margin-left: 15px;
    transform: rotate(90deg) translateX(-50%);
    transform-origin: top left;

    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    background: #dddddd;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    text-decoration: none;
    color: #777777;

    i {
      margin: 0 8px;

      &:before {
        font-weight: bold;
      }
    }
  }
}

.scroll-contain {
  display: block;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 20px;
}

.is-open {
  transform: translate3d(0, 0, 0);
}
</style>
